import { Box } from '@mui/material';
import { IItemsProps } from './NewMeeting';
import OverviewTicket, { ItemTypes } from '../Home Page/OverviewTicket';
import { useDrop } from 'react-dnd';
import { useState } from 'react';
import EditMeetingBoard from './EditMeetingBoard';

const RollingItemsBoard = (props: { items: IItemsProps }) => {
  const [commentOpen, setCommentOpen] = useState(false);    
  const [ticketId, setTicketId] = useState<number>(0);  
  const [idToDrop, setIdToDrop] = useState<number>(0);    
 
  const [, drop] = useDrop(() => ({
    accept: ItemTypes.ITEM,
    drop: (item: { idToDrop: number; data: { id: number } }) => {
      if (!props?.items?.rollingItems.includes(item?.idToDrop)) {
        setIdToDrop(item?.idToDrop);
        setCommentOpen(true);
        setTicketId(item?.data?.id);
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  const handleDrop = (idToDrop: number) => {
    props?.items?.setRollingItems((oldData) => [...oldData, idToDrop]);
    props?.items?.setDiscussions((oldData) => oldData?.filter((data) => data !== idToDrop));
    props?.items?.setActionItems((oldData) => oldData?.filter((data) => data !== idToDrop));
    props?.items?.setDecisions((oldData) => oldData?.filter((data) => data !== idToDrop));
  };

  return (
    <>
      <Box display='flex' flexDirection='column' gap='5px' p='5px' alignItems='center'>
        <Box fontWeight='bold' fontSize='14px'>ROLLING</Box>
        <Box
          ref={drop}
          height='calc(100vh - 230px)'
          border='1px dashed gray'
          borderRadius='10px'
          width='300px'
          display='flex'
          flexDirection='column'
          gap='10px'
          p='10px'
          sx={{
            overflowY: 'scroll',
            '&::-webkit-scrollbar': {
              width: '3px',
            },
          }}
        >
          {props?.items?.rollingItemsArray?.map((item) => {
            return <OverviewTicket key={item?.id} data={item} />;
          })}
        </Box>
      </Box>
      <EditMeetingBoard
        commentOpen={commentOpen}
        setCommentOpen={setCommentOpen}
        type={'ROLLING'}
        ticketId={ticketId}
        idToDrop={idToDrop}
        handleDrop={handleDrop}
      />
    </>
  );
};

export default RollingItemsBoard;
